/**
 * Creates an absolute URL from a path, relative to the loation
 * from which this page was loaded.
 *
 * @param path  absolute path on this host
 */
export function internalUrl(path: string): string {
    const sanitizedPath = path.replace(/^\/+(.*)/, '$1');
    return `${document.baseURI}/${sanitizedPath}`.replace(/(?<!:)\/+/g, '/');
}

export function getLastPath(url: URL): string {
    const pathname = url.pathname;
    const paths = pathname.split('/');
    const last = paths.pop() || paths.pop();
    return decodeURI(last);
}
